import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";
import { adminApi } from "../../lib/adminApi";

export default function AdminCampusLocationList() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  async function load() {
    try { setRows(await adminApi("/api/admin/campus-locations")); }
    catch (err) { setError(err.message); }
  }

  useEffect(() => { load(); }, []);

  async function remove(id) {
    if (!window.confirm("Delete this campus location?")) return;
    try { await adminApi(`/api/admin/campus-locations/${id}`, { method: "DELETE" }); load(); }
    catch (err) { alert(err.message); }
  }

  return (
    <AdminLayout title="Campus Map CMS" subtitle="Manage public campus locations, service points and virtual tour links." actions={<Link to="/adxm/campus-locations/create" className="rounded-xl bg-emerald-700 px-4 py-3 font-bold text-white">Add Location</Link>}>
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
      <div className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-slate-200">
        <table className="w-full min-w-[900px] text-sm">
          <thead className="bg-slate-100 text-left text-slate-600"><tr><th className="p-4">Location</th><th className="p-4">Category</th><th className="p-4">Map Point</th><th className="p-4">Status</th><th className="p-4">Actions</th></tr></thead>
          <tbody>
            {rows.map((item) => <tr key={item.id} className="border-t border-slate-100"><td className="p-4 font-black">{item.name}</td><td className="p-4">{item.category}</td><td className="p-4">{item.map_x || 50}%, {item.map_y || 50}%</td><td className="p-4"><span className="rounded-full bg-slate-100 px-3 py-1 font-bold">{item.status}</span></td><td className="p-4"><div className="flex gap-3"><Link className="font-bold text-blue-700" to={`/adxm/campus-locations/edit/${item.id}`}>Edit</Link><button className="font-bold text-red-700" onClick={() => remove(item.id)}>Delete</button></div></td></tr>)}
            {rows.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-slate-500">No campus locations yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
